import React, {useEffect} from 'react';
import styled from 'styled-components';
import {
  Button,
  ActionButton,
  ButtonGroup,
  Content,
  Dialog,
  DialogTrigger,
  Heading,
  Flex,
  Text,
  View,
  ProgressCircle,
  Switch,
  Link
} from '@adobe/react-spectrum';
import useFeedbackSettings from "state/recommendations/hooks/useFeedbackSettings";

const TopLine = styled.hr`
  border: 1px solid #eaeaea;
  margin: 12px 0 16px 0;
  grid-area: divider;
`;

const EnabledBadge = styled.span`
  background-color: #e6f4ea;
  color: #1e7e34;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
`;

const feedbackSettingsButton = () => {
  const [optedOut, isLoading, loadFeedbackSettings, updateFeedbackOptedOut] = useFeedbackSettings();

  useEffect(() => {
    loadFeedbackSettings();
  }, []);

  return (
    <DialogTrigger>
         <div className="spectrum-Table-headCell d-inline-flex" style={{ paddingRight: 0 }}>
          <ActionButton>
            <span className="spectrum-ActionButton-label" style={{"padding":"0 5px"}}>Feedback Preferences</span>
          </ActionButton>
         </div>
      {close => (
        <Dialog>
          <Heading>Feedback Preferences</Heading>
          <TopLine />
          <Content>
            {isLoading
              ? <ProgressCircle aria-label="Loading…" isIndeterminate/>
              : <Flex direction="column" gap="size-100">
                  <Flex direction="row" alignItems="center" gap="size-100">
                    <Switch
                      isSelected={!optedOut}
                      onChange={isSelected => updateFeedbackOptedOut(!isSelected)}
                      UNSAFE_className="feedbackSwitch"
                    >
                     <span style={{fontWeight:"bold"}}>Allow Adobe to collect my feedback on recommendations</span>
                    </Switch>
                    {!optedOut && <EnabledBadge>Enabled</EnabledBadge>}
                  </Flex>
                  <Text UNSAFE_style={{fontSize: '14px'}}>
                    When enabled, Adobe collects thumbs ratings, flag reasons, and
                    optional comments you submit on SWAT recommendations. Used to
                    improve recommendation accuracy. Never sold or shared outside
                    Adobe.
                  </Text>
                  {/* TODO: re-enable once data deletion requests are supported
                  <TopLine />
                  <Text UNSAFE_style={{fontSize: '12px', color: '#6e6e6e'}}>
                    Opting out does not delete feedback already submitted.{' '}
                    <Link isQuiet>
                      <a href="#">Request data deletion</a>
                    </Link>
                  </Text>
                  */}
                </Flex>
            }
          </Content>
          <ButtonGroup>
            <Button variant="cta" onPress={close}>
              Close
            </Button>
          </ButtonGroup>
        </Dialog>
      )}
    </DialogTrigger>
  );
};
export default feedbackSettingsButton;
